import { useEffect, useState } from "react";
import axios from "axios";
import styles from "../../assets/styles/Homepage/VideoHero.module.css";
import bgVideo from "../../assets/images/risikesh.mp4";
const ENV_API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8000";

const API = `${ENV_API_BASE_URL}/api/home-video-section-two`;

const DEFAULT_SECTION = {
  heading: "Deepen and Enhance The Quality of Your Teachings",
  description:
    "Our program focuses on refining your techniques, understanding the subtleties of alignment, and mastering the art of effective communication.",
  video: bgVideo,
};

const VideoHero = () => {
  const [section, setSection] = useState(DEFAULT_SECTION);

  useEffect(() => {
    const fetchSection = async () => {
      try {
        const res = await axios.get(API);
        const latest = res.data?.data;
        if (!latest) return;

        setSection({
          heading: latest.heading || DEFAULT_SECTION.heading,
          description: latest.description || DEFAULT_SECTION.description,
          video: latest.videoUrl || DEFAULT_SECTION.video,
        });
      } catch (error) {
        console.error("Failed to load home video section two", error);
      }
    };

    fetchSection();
  }, []);

  return (
    <section className={styles.hero}>
      
      {/* Background Video */}
      <video
        className={styles.video}
        src={section.video}
        autoPlay
        muted
        loop
        playsInline
      />

      {/* Overlay */}
      <div className={styles.overlay}></div>

      {/* Content */}
      <div className={styles.content}>
        <h2 className={styles.title}>
          {section.heading}
        </h2>

        <p className={styles.text}>
          {section.description}
        </p>
      </div>

    </section>
  );
};

export default VideoHero;
